import CustomZObject from './CustomZObject.js';
import {definitions} from './canvas/index.js';
import {isNumber} from "utils/IsNumber.js";

export default class ZAttributes extends CustomZObject {
    constructor(zobject) {
        super(zobject);

        this.newInlet("operation", ([msg]) => this.onOperation(msg));
        this.customAttributes = [];
    }

    get subpatch() {
        if (this.subSequence.zObject) {
            return this.subSequence;
        }
        return undefined;
    }

    loadBang() {
        if (!this.subpatch) {
            return;
        }
        let attributes = this.subpatch.zObject.attributes;
        for (let attribute in attributes) {
            this.subpatch.zObject.setAttribute(attribute, attributes[attribute]);
        }
    }

    onOperation(operation) {
        if (!this.subpatch) {
            return;
        }
        let tokens = operation.split(" ");

        if (tokens[0] === "create") {
            this.customAttributes.push(tokens[1]);
            this.newOutlet("Attribute " + tokens[1]);

            // how do we the subpatch to this object?
            this.subpatch.zObject.newAttribute(tokens[1], '', (x) => {
                this.sendMessage("Attribute " + tokens[1], x);
            });
        }
    }

    getJson(isPreset) {
        return {
            ... super.getJson(isPreset),
            customAttributes: this.customAttributes
        };
    }
    fromJson(json, isCopy) {
        super.fromJson(json);

        if (json.customAttributes) {
            json.customAttributes = Array.from(new Set(json.customAttributes));
            for (let attribute of json.customAttributes) {
                this.onOperation("create " + attribute);
            }
        }
    }
}
 
